export const OfflineImage = () => {
  return (
    <svg
      width="166"
      height="95"
      viewBox="0 0 166 95"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M50.3008 82.3543C70.3353 82.3543 86.5776 66.1121 86.5776 46.0061C86.5776 25.9 70.2638 9.65778 50.3008 9.65778C30.2664 9.65778 14.0241 25.9 14.0241 46.0061C14.0241 66.1121 30.2664 82.3543 50.3008 82.3543Z"
        fill="#EAEEF9"
      />
      <path
        d="M15.956 22.1078C17.0625 22.1078 17.9595 21.2108 17.9595 20.1043C17.9595 18.9979 17.0625 18.1009 15.956 18.1009C14.8495 18.1009 13.9526 18.9979 13.9526 20.1043C13.9526 21.2108 14.8495 22.1078 15.956 22.1078Z"
        fill="#E7EBF6"
      />
      <path
        d="M3.72069 60.7457C5.77557 60.7457 7.44138 59.0799 7.44138 57.025C7.44138 54.9701 5.77557 53.3043 3.72069 53.3043C1.66581 53.3043 0 54.9701 0 57.025C0 59.0799 1.66581 60.7457 3.72069 60.7457Z"
        fill="#E7EBF6"
      />
      <path
        opacity="0.2"
        d="M35.6293 67.4782L65.681 62.1029C66.6483 62.1029 67.3638 66.5836 66.3965 66.7543C57.634 68.5751 47.5213 71.6319 53.6096 75.3304C63.9654 81.5894 80.1249 84.7758 99.357 81.1911C117.556 78.9181 115.052 76.6797 110.759 75.3304C103.961 73.194 71.7629 81.7335 92.1552 69.0714C103.961 67.4782 117.556 69.0714 117.556 69.0714C119.946 69.0714 68.9295 81.1911 99.357 59.9563C109.328 54.2322 111.171 63.3603 121.491 62.1029"
        stroke="#9CA3B2"
        strokeWidth="2.27599"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33.6293 66.4782L63.681 61.1029C64.6483 61.1029 65.3638 65.5836 64.3965 65.7543C55.634 67.5751 45.5213 70.6319 51.6096 74.3304C61.9654 80.5894 78.1249 83.7758 97.357 80.1911C115.556 77.9181 113.052 75.6797 108.759 74.3304C101.961 72.194 69.7629 80.7335 90.1552 68.0714C101.961 66.4782 115.556 68.0714 115.556 68.0714C117.946 68.0714 66.9295 80.1911 97.357 58.9563C107.328 53.2322 109.171 62.3603 119.491 61.1029"
        stroke="#A8AFBE"
        strokeWidth="2.27599"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M125.041 66.8518C124.923 67.1676 124.578 67.3253 124.262 67.2077L121.208 66.0699C120.893 65.9522 120.735 65.6072 120.852 65.2914C120.97 64.9756 121.315 64.8179 121.631 64.9355L124.685 66.0733C125.036 66.2042 125.162 66.5278 125.041 66.8518Z"
        fill="#ADB6C8"
        stroke="#A8AFBE"
        strokeWidth="0.465584"
      />
      <path
        d="M126.552 62.7942C126.435 63.1101 126.09 63.2678 125.774 63.1501L122.72 62.0124C122.404 61.8947 122.246 61.5497 122.364 61.2339C122.482 60.9181 122.827 60.7604 123.142 60.878L126.196 62.0158C126.548 62.1467 126.673 62.4703 126.552 62.7942Z"
        fill="#ADB6C8"
        stroke="#A8AFBE"
        strokeWidth="0.465584"
      />
      <path
        d="M123.662 64.2312C123.592 64.4186 123.49 64.5596 123.392 64.6403C123.29 64.725 123.231 64.7168 123.216 64.7111L121.456 64.0556C121.441 64.0498 121.391 64.0178 121.369 63.8868C121.348 63.762 121.363 63.5885 121.433 63.4011C121.503 63.2137 121.605 63.0727 121.703 62.992C121.805 62.9073 121.863 62.9155 121.879 62.9212L123.638 63.5768C123.67 63.5885 123.716 63.6244 123.734 63.7452C123.752 63.8669 123.733 64.0388 123.662 64.2312Z"
        fill="#ADB6C8"
        stroke="#A8AFBE"
        strokeWidth="0.465584"
      />
      <path
        d="M120.611 67.1393L119.913 66.8792C118.847 66.4821 117.53 65.4989 116.582 64.3372C116.11 63.7582 115.738 63.1452 115.534 62.5509C115.33 61.957 115.298 61.3965 115.481 60.9055C115.664 60.4146 116.055 60.0117 116.598 59.6961C117.141 59.3802 117.823 59.1599 118.559 59.031C120.036 58.7724 121.675 58.8906 122.741 59.2878L123.439 59.5478L120.611 67.1393Z"
        fill="#ADB6C8"
        stroke="#A8AFBE"
        strokeWidth="0.465584"
      />
      <g filter="url(#filter0_d_7_5121)">
        <path
          d="M84.8683 26.9138V69.0131C84.8683 70.2483 83.839 71.2777 82.6038 71.2777H18.6313C17.3961 71.3291 16.3668 70.2998 16.3668 69.0646V26.9138C16.3668 25.6271 17.3961 24.6493 18.6313 24.6493H82.6038C83.8904 24.6493 84.8683 25.6786 84.8683 26.9138Z"
          fill="url(#paint0_linear_7_5121)"
        />
        <path
          d="M18.6313 71.1777V71.1776L18.6271 71.1777C17.4512 71.2267 16.4668 70.2454 16.4668 69.0646V26.9138C16.4668 25.6838 17.4498 24.7493 18.6313 24.7493H82.6038C83.8337 24.7493 84.7683 25.7323 84.7683 26.9138V69.0131C84.7683 70.1931 83.7837 71.1777 82.6038 71.1777H18.6313Z"
          stroke="black"
          strokeWidth="0.2"
        />
      </g>
      <path
        d="M84.7683 26.9138V30.0561H16.4668V26.9138C16.4668 25.6838 17.4498 24.7493 18.6313 24.7493H82.6038C83.8337 24.7493 84.7683 25.7323 84.7683 26.9138Z"
        fill="url(#paint1_linear_7_5121)"
        stroke="black"
        strokeWidth="0.2"
      />
      <path
        d="M42.2435 47.0686C39.4372 47.0686 37.0799 45.2732 36.1819 42.6922C35.9574 42.1311 36.2942 41.57 36.8554 41.3456C37.4167 41.1211 37.9779 41.4578 38.2024 42.0189C38.7637 43.7021 40.4475 44.9365 42.2435 44.9365C44.0395 44.9365 45.7233 43.8143 46.2845 42.0189C46.509 41.4578 47.0703 41.1211 47.6316 41.3456C48.1928 41.57 48.5296 42.1311 48.3051 42.6922C47.4071 45.3854 45.0498 47.0686 42.2435 47.0686Z"
        fill="#444850"
      />
      <path
        d="M59.1935 47.0686C56.3872 47.0686 54.0299 45.2732 53.1319 42.6922C52.9074 42.1311 53.2442 41.57 53.8054 41.3456C54.3667 41.1211 54.928 41.4578 55.1525 42.0189C55.7137 43.7021 57.3975 44.9365 59.1935 44.9365C60.9895 44.9365 62.6733 43.8143 63.2346 42.0189C63.4591 41.4578 64.0203 41.1211 64.5816 41.3456C65.1428 41.57 65.4796 42.1311 65.2551 42.6922C64.3571 45.3854 61.9998 47.0686 59.1935 47.0686Z"
        fill="#444850"
      />
      <path
        d="M51.1803 60.8085C52.6062 60.8085 53.7621 59.6529 53.7621 58.2275C53.7621 56.802 52.6062 55.6465 51.1803 55.6465C49.7545 55.6465 48.5986 56.802 48.5986 58.2275C48.5986 59.6529 49.7545 60.8085 51.1803 60.8085Z"
        fill="#444850"
      />
      <path
        d="M19.4032 28.3547C19.8296 28.3547 20.1752 28.0091 20.1752 27.5827C20.1752 27.1564 19.8296 26.8107 19.4032 26.8107C18.9769 26.8107 18.6313 27.1564 18.6313 27.5827C18.6313 28.0091 18.9769 28.3547 19.4032 28.3547Z"
        fill="#F9FAFB"
      />
      <path
        d="M21.8222 28.3547C22.2485 28.3547 22.5942 28.0091 22.5942 27.5827C22.5942 27.1564 22.2485 26.8107 21.8222 26.8107C21.3958 26.8107 21.0502 27.1564 21.0502 27.5827C21.0502 28.0091 21.3958 28.3547 21.8222 28.3547Z"
        fill="#F9FAFB"
      />
      <path
        d="M24.2926 28.3547C24.7189 28.3547 25.0646 28.0091 25.0646 27.5827C25.0646 27.1564 24.7189 26.8107 24.2926 26.8107C23.8662 26.8107 23.5206 27.1564 23.5206 27.5827C23.5206 28.0091 23.8662 28.3547 24.2926 28.3547Z"
        fill="#F9FAFB"
      />
      <path
        d="M83.1407 14.9216H91.9656V18.0485H78.7026V14.8576L87.4532 4.29973L87.589 4.13592H87.3762H79.1564V1.009H91.8143V4.19986L83.0637 14.7578L82.9279 14.9216H83.1407Z"
        fill="#444850"
        stroke="black"
        strokeWidth="0.2"
      />
      <path
        d="M98.3793 32.1376H104.028V34.0547H95.4539V32.0734L101.028 25.296L101.163 25.1325H100.951H95.7564V23.2154H103.876V25.1966L98.302 31.974L98.1676 32.1376H98.3793Z"
        fill="#444850"
        stroke="black"
        strokeWidth="0.2"
      />
      <path
        d="M90.4512 41.9693H93.6327V42.9779H88.8241V41.9051L91.9965 38.048L92.131 37.8845H91.9193H88.9968V36.8759H93.5464V37.9486L90.374 41.8058L90.2395 41.9693H90.4512Z"
        fill="#444850"
        stroke="black"
        strokeWidth="0.2"
      />
      <path
        d="M143.746 55.2738H143.745L143.746 55.2786C143.777 55.7508 143.366 56.1693 142.85 56.1693H129.76C129.249 56.1693 128.865 55.7541 128.865 55.2738V41.3205C128.865 40.8091 129.28 40.425 129.76 40.425H142.85C143.361 40.425 143.746 40.8403 143.746 41.3205V55.2738Z"
        fill="#EAEEF9"
        stroke="black"
        strokeWidth="0.143103"
      />
      <path
        d="M141.155 48.0209C141.155 49.6125 140.38 51.0695 139.2 51.9558H133.341C132.161 51.0697 131.386 49.6466 131.386 48.0209C131.386 46.4293 132.161 44.9723 133.341 44.0861H139.199C140.381 45.0067 141.155 46.4302 141.155 48.0209Z"
        fill="#C7D0DD"
        stroke="black"
        strokeWidth="0.143103"
      />
      <path
        d="M134.423 48.2257C134.221 48.2257 134.045 48.0505 134.045 47.8482V46.3631C134.045 46.1609 134.221 45.9857 134.423 45.9857C134.625 45.9857 134.8 46.1609 134.8 46.3631V47.8482C134.8 48.0505 134.625 48.2257 134.423 48.2257Z"
        fill="#989FB0"
        stroke="black"
        strokeWidth="0.143103"
      />
      <path
        d="M138.049 48.2257C137.847 48.2257 137.672 48.0505 137.672 47.8482V46.3631C137.672 46.1609 137.847 45.9857 138.049 45.9857C138.251 45.9857 138.427 46.1609 138.427 46.3631V47.8482C138.427 48.0505 138.251 48.2257 138.049 48.2257Z"
        fill="#989FB0"
        stroke="black"
        strokeWidth="0.143103"
      />
      <path
        d="M136.668 50.367H135.77C135.598 50.367 135.427 50.2225 135.427 50.0241V49.5751C135.427 49.1311 135.775 48.7832 136.219 48.7832C136.663 48.7832 137.011 49.1311 137.011 49.5751V50.0241C137.011 50.1957 136.866 50.367 136.668 50.367Z"
        fill="#989FB0"
        stroke="black"
        strokeWidth="0.143103"
      />
      <path
        d="M130.382 42.4603C130.706 42.4603 130.969 42.1974 130.969 41.8731C130.969 41.5489 130.706 41.286 130.382 41.286C130.058 41.286 129.795 41.5489 129.795 41.8731C129.795 42.1974 130.058 42.4603 130.382 42.4603Z"
        fill="#D2DAE7"
      />
      <path
        d="M142.297 42.4603C142.622 42.4603 142.885 42.1974 142.885 41.8731C142.885 41.5489 142.622 41.286 142.297 41.286C141.973 41.286 141.71 41.5489 141.71 41.8731C141.71 42.1974 141.973 42.4603 142.297 42.4603Z"
        fill="#D2DAE7"
      />
      <path
        d="M130.382 55.3429C130.706 55.3429 130.969 55.0801 130.969 54.7558C130.969 54.4315 130.706 54.1686 130.382 54.1686C130.058 54.1686 129.795 54.4315 129.795 54.7558C129.795 55.0801 130.058 55.3429 130.382 55.3429Z"
        fill="#D2DAE7"
      />
      <path
        d="M142.297 55.3429C142.622 55.3429 142.885 55.0801 142.885 54.7558C142.885 54.4315 142.622 54.1686 142.297 54.1686C141.973 54.1686 141.71 54.4315 141.71 54.7558C141.71 55.0801 141.973 55.3429 142.297 55.3429Z"
        fill="#D2DAE7"
      />
      <defs>
        <filter
          id="filter0_d_7_5121"
          x="0.625381"
          y="16.7786"
          width="99.9843"
          height="78.113"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="7.87069" />
          <feGaussianBlur stdDeviation="7.87069" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_7_5121"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_7_5121"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_7_5121"
          x1="50.5952"
          y1="23.5707"
          x2="50.5952"
          y2="71.7822"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FDFEFF" />
          <stop offset="0.9964" stopColor="#ECF0F5" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_7_5121"
          x1="82.151"
          y1="24.6493"
          x2="18.5741"
          y2="27.4027"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B0BACC" />
          <stop offset="1" stopColor="#444850" />
        </linearGradient>
      </defs>
    </svg>
  );
};
